import { Container } from '@ui/wrapper'
import Accordion from '@ui/accordion'
import { SectionWrapper, StyledText } from './style'

const PressemitteilungenArea = ({ data, dataEUSIPA, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.section_title?.title && (
          <StyledText id="bsw">
            <h4>{data.section_title.title}</h4>
          </StyledText>
        )}
        {data?.items?.length > 0 && (
          <StyledText>
            <Accordion data={data.items} />
          </StyledText>
        )}
        {dataEUSIPA?.section_title?.title && (
          <StyledText id="eusipa" style={{ marginTop: '60px' }}>
            <h4>{dataEUSIPA.section_title.title}</h4>
          </StyledText>
        )}
        {dataEUSIPA?.items?.length > 0 && (
          <StyledText>
            <Accordion data={dataEUSIPA.items} />
          </StyledText>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default PressemitteilungenArea
